import { FileFormat } from '../../../shared/types/resultsDownload';

export const fileFormatsResultsDownload = [FileFormat.json, FileFormat.list];

export const fileFormatEntryDownload = [FileFormat.json];
